export default __webpack_public_path__ + "static/media/Disaster_relief_with_V.bde62132.jpg";